export default "__VITE_ASSET__DpKLQYfk__"